import CircleLocation from '@/components/icons/circleLocation'
import CircleCar from '@/components/icons/circleCar'
import CircleCalendar from '@/components/icons/circleCalendar'
import Divider from '@/components/divider'
import { Typography } from '@/components/ui/typography'
import phoneMock from '@/assets/home/phone-mock.webp'

export function HowItWorks() {
  return (
    <div className="container mt-12">
      <p id="about" className="text-red mb-2 text-lg font-medium">
        Jak to funguje
      </p>
      <div className="mb-12 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-16">
        <Typography variant="h2">Milujete útěky z města do přírody? Stačí jen pár kroků!</Typography>
        <p className="text-base text-slate-400 lg:text-lg">
          Vyberte si z nabídky právě uvolněných míst a vyražte vstříc novým zážitkům bez složitého navolávání. Prostě
          rezervujte volné ubytování a jeďte.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="hidden justify-center md:flex">
          <img src={phoneMock} alt="Phone mock" className="max-h-144" />
        </div>

        <div className="text-sm md:justify-end">
          <div className="flex max-w-120 flex-col gap-2 rounded-xl bg-slate-100 px-2 py-2">
            <div className="flex items-center gap-4 rounded-xl bg-white px-2 py-4 pt-2 pb-6 shadow-xl shadow-slate-200 lg:gap-6 lg:px-6 lg:py-8">
              <div className="hidden lg:block">
                <CircleLocation />
              </div>
              <div className="flex flex-col text-slate-600 lg:gap-0">
                <div className="flex items-center text-base font-medium lg:text-lg">
                  <CircleLocation className="scale-70 lg:hidden" />
                  Vyberete místo a termín
                </div>
                <p className="px-4 lg:px-0">V naší nabídce najdete volné chalupy, roubenky, ale i hotely a penziony.</p>
              </div>
            </div>
            <div className="flex items-center gap-4 px-0 py-4 pt-2 pb-6 lg:gap-6 lg:px-6 lg:py-8">
              <div className="hidden lg:block">
                <CircleCalendar />
              </div>
              <div className="flex flex-col text-slate-600 lg:gap-0">
                <div className="flex items-center text-base font-medium lg:text-lg">
                  <CircleCalendar className="scale-70 lg:hidden" />
                  Koupíte ubytování
                </div>
                <p className="px-4 lg:px-0">Po zaplacení v platební bráně obdržíte e-mail s potvrzením a detaily.</p>
              </div>
            </div>
            <Divider size="zero" className="mx-4 my-1" />
            <div className="flex items-center gap-4 px-0 py-4 pt-2 pb-6 lg:gap-6 lg:px-6 lg:py-8">
              <div className="hidden lg:block">
                <CircleCar />
              </div>
              <div className="flex flex-col text-slate-600 lg:gap-0">
                <div className="flex items-center text-base font-medium lg:text-lg">
                  <CircleCar className="scale-70 lg:hidden" />
                  Už stačí jen zabalit a jet
                </div>
                <p className="px-4 lg:px-0">Do e-mailu vám pošleme potvrzení o platbě a všechny potřebné informace.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider size="xl" className="md:mt-0!" />
    </div>
  )
}
